import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiperWrapper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="four-up"',
}

const initSwiper = (section) => {
  const swiperWrapper = section.querySelector(`[${qs.swiperWrapper}]`)
  const sliderStyle = swiperWrapper.dataset.mediaSwiper
  window.addEventListener('resize', () => {
    setupSwiper(swiperWrapper, sliderStyle)
  })
  setupSwiper(swiperWrapper, sliderStyle)
}

const setupSwiper = (swiperWrapper, sliderStyle) => {
  if(!swiperWrapper.classList.contains('swiper-initialized') && window.innerWidth < 990) {
    if(sliderStyle == 1) {
      new Swiper(swiperWrapper, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 17,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    } else {
      new Swiper(swiperWrapper, {
        slidesPerView: 1.4,
        slidesPerGroup: 1,
        spaceBetween: 17,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
            slidesPerView: 1.4,
            slidesPerGroup: 1,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          }
        }
      });
    }
  } else if(swiperWrapper.classList.contains('swiper-initialized') && window.innerWidth >= 990) {
    swiperWrapper.swiper.destroy(true, true);
  }
}

export const setupFourUp = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSwiper(section))
}